module.exports = __webpack_public_path__ + "static/media/startZone.54436bcb.png";